//Backward compatibility method
export function getPageSettings(fieldName:string){
    const fieldNameLowerCase = fieldName.toLowerCase();
    const pageSettingsElement = document.getElementById('page-settings');
    if(!pageSettingsElement)
        return getNewPageSettings(fieldNameLowerCase);
        
    const rawString = pageSettingsElement.outerHTML.split("value=")[1].toLowerCase();
    // Check if the field exists in the rawString
    if(!rawString.includes(fieldNameLowerCase)) {
        return "";
    }
    
    try {
        const splitResult = rawString.split(fieldNameLowerCase)[1];
        const str = splitResult.split(",")[0];
        let cleanedString = str
        .replace(/\"/g, '')    // Remove all double quotes
        .replace(/=/g, '')     // Remove equal signs
        .replace(/^:/, '')     // Remove leading colon
        .replace(/\s+/g, ' ')  // Replace multiple spaces with a single space
        .trim();
        
        return cleanedString.toLowerCase() || "";
    } catch(error) {
        console.warn(`Error parsing field ${fieldNameLowerCase} from page settings, either no settings reccieved from CP or invalid JSON`, error);
        return "";
    }
}

//Updated function to access the new page settings US #523504
function getNewPageSettings(fieldName:string){
    const pageSettingsElement = document.getElementById('page-settings-object');
    if(!pageSettingsElement)
        return;
        
    // Explicitly accessing textContent which is a valid property of HTMLElement
    const settingsObject = pageSettingsElement.textContent;
    if(!settingsObject)
        return;
        
    try {
        const settings = convertKeysToLowerCase(JSON.parse(settingsObject));
        return settings[fieldName] ?? "";
    } catch (error) {
        console.warn(`Error parsing field ${fieldName} from page settings, either no settings reccieved from CP or invalid JSON`, error);
        return "";
    }
}

function convertKeysToLowerCase(obj: Record<string, any>): Record<string, any> {
    return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => [key.toLowerCase(), typeof value === "string" ? value.toLowerCase() : value])
    );
}
